import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators'
import { AuthServices } from '@/services/modules/auth.service'
import { APIAuth, APIResetPassword } from '@/models/api/auth.model'
import store from '@/store'
import router from '@/router'

@Module
export default class AuthStore extends VuexModule {
    auth: object|null = null

    @Mutation
    updateAuth (newAuth: object) {
        this.auth = newAuth
    }

    @Action
    saveRouteInLocalStorage () {
        return new Promise(resolve => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const actualRoute = (router as any).match(window.location.pathname + window.location.search)

            if (!actualRoute.name || actualRoute.name === 'Login') {
                if (!actualRoute.name) resolve(false)
                if (actualRoute.name === 'Login') resolve(false)
            } else {
                const route = {
                    name: actualRoute.name,
                    params: actualRoute.params,
                    query: actualRoute.query
                }

                localStorage.setItem('goToRouteOnLogin', JSON.stringify(route))
                resolve(true)
            }
        })
    }

    get Token () {
        return this.auth || null
    }

    @Action
    login (credentials: APIAuth) {
        credentials = new APIAuth(credentials)
        return new Promise((resolve) => {
            if (!(credentials instanceof APIAuth)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            AuthServices.login(credentials)
                .then(resp => {
                    if (resp.status === 200) {
                        store.commit('updateAuth', resp.data)
                        localStorage.setItem('auth', JSON.stringify(resp.data))
                    }
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    sendResetPasswordPin (email: string) {
        return new Promise((resolve) => {
            AuthServices.sendPin(email)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    resetPasswordPin (data: APIResetPassword) {
        return new Promise((resolve) => {
            AuthServices.resetPasswordPin(data)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
